export default __webpack_public_path__ + "static/media/mg-grey.9e5a40b5.svg";